import engine from './engine.js';

const keys = {
  house: 'house',
  transport: 'transport',
  personal: 'personal',
  eatout: 'eatout',
  holiday: 'holiday',
  food: 'food',
  treat: 'treat',
}

const config = {
  ...engine,
  questionAnswerData: {
    cohabitingQuestion: {
      question: 'Are you co-habiting?',
      answers: {
        A: 'I live on my own',
        B: 'I live with my partner'
      }
    },
    single: {
      [keys.house]: {
        question: 'What will your home in retirement be like?',
        answers: {
          A: 'The essentials are enough for me',
          B: 'Well furnished - I like a few home comforts',
          C: 'Instagram worthy, with all the mod cons',
        }
      },
      [keys.transport]: {
        question: 'How are you going to get around?',
        answers: {
          A: "I'll hop on the bus",
          B: "I'll drive a mid-range car",
          C: "Comfort is key for me - I'd like a luxury car",
        }
      },
      [keys.personal]: {
        question: 'Will you treat yourself to new clothes and cosmetics?',
        answers: {
          A: "I'm pretty low maintenance",
          B: "I like to look good - I'll splash out occasionally",
          C: "I'm all about designer brands and high-end cosmetics",
        }
      },
      [keys.eatout]: {
        question: "You're eating out... where are you heading?",
        answers: {
          A: 'The chippy',
          B: 'The local pub',
          C: 'My nearest bistro',
        }
      },
      [keys.holiday]: {
        question: 'Are you planning to do much travelling?',
        answers: {
          A: 'Mainly UK-based trips here and there',
          B: 'Two to three trips a year, across the UK and Europe',
          C: 'Three or four holidays each year, somewhere more exotic',
        }
      },
      [keys.food]: {
        question: "You're eating in... what's for dinner?",
        answers: {
          A: "I'm content with food that's simple and fresh",
          B: "I tend to opt for the more premium brands",
          C: "Top of the range all the way",
        }
      },
      [keys.treat]: {
        question: "You're treating the family... what'll it be?",
        answers: {
          A: 'A trip to the cinema',
          B: 'A mini shopping spree',
          C: 'A full day out, plus souvenirs galore!',
        }
      },
    },
    // uncomment and populate below if we ever add different question/answer copy. Will also need to update config/index.js getQuestionAnswerData getter
    // cohabiting: {
    //   [keys.house]: {},
    //   [keys.transport]: {},
    //   [keys.personal]: {},
    //   [keys.eatout]: {},
    //   [keys.holiday]: {},
    //   [keys.food]: {},
    //   [keys.treat]: {},
    // }
  },
  currencySymbol: '£',
  headlineFigures: {
    single: {
      minimum: 13400,
      moderate: 31700,
      comfortable: 43900,
    },
    cohabiting: {
      minimum: 21600,
      moderate: 43900,
      comfortable: 60600,
    }
  },
  inputs: {
    age: {
      min: 18,
      max: 100,
      currentValue: 20, // initial value
    },
    retirementAge: {
      min: 50,
      max: 100,
      currentValue: 70, //initial value
    },
    currentBalance: {
      min: 0,
      max: 1000000,
      currentValue: 0,  //initial value
    },
  },
  engine: {
    interestRate: 0.04,
    statePension: 11973,
    annuityRate: 20,
  },
  targetIncomes: {
    single: {
      [keys.house]: {
        A: 109.48,
        B: 228.14,
        C: 338.04,
      },
      [keys.food]: {
        A: 33.75,
        B: 66.94,
        C: 86.43,
      },
      [keys.eatout]: {
        A: 36.83,
        B: 71.41,
        C: 93.85,
      },
      [keys.transport]: {
        A: 10.36,
        B: 89.67,
        C: 104.62,
      },
      [keys.holiday]: {
        A: 19.33,
        B: 48.61,
        C: 90.64,
      },
      [keys.treat]: {
        A: 10.98,
        B: 27.62,
        C: 51.5,
      },
      [keys.personal]: {
        A: 42.66,
        B: 82.87,
        C: 88.29,
      }
    },
    cohabiting: {
      [keys.house]: {
        A: 142.68,
        B: 275.34,
        C: 408.81,
      },
      [keys.food]: {
        A: 64.89,
        B: 113.06,
        C: 145.11 ,
      },
      [keys.eatout]: {
        A: 71.8,
        B: 122.54,
        C: 158.44,
      },
      [keys.transport]: {
        A: 13.81,
        B: 90.33,
        C: 107.59,
      },
      [keys.holiday]: {
        A: 29,
        B: 68.98,
        C: 126.35,
      },
      [keys.treat]: {
        A: 16.48,
        B: 39.19,
        C: 71.79,
      },
      [keys.personal]: {
        A: 76.15,
        B: 132.53,
        C: 143.51,
      }
    }
  },
  canChangeRetirementAge: true,
};

export default config;
